type ScoreLabel = 'none' | 'bad' | 'poor' | 'average' | 'good' | 'excellent'

type ScoreConfig = {
  below: number
  label: ScoreLabel
}

const SCORE_THRESHOLDS: ScoreConfig[] = [
  { below: 6, label: 'bad' },
  { below: 7, label: 'poor' },
  { below: 7.5, label: 'average' },
  { below: 8.5, label: 'good' },
  { below: Infinity, label: 'excellent' },
]

function getThreshold(score: number) {
  return SCORE_THRESHOLDS.find((threshold) => score < threshold.below)
}

export function getScoreLabel(score: number | null | undefined) {
  if (typeof score !== 'number') {
    return 'none'
  }
  return getThreshold(score)?.label ?? 'none'
}
